import { Component, OnInit } from '@angular/core';
import { OfferService } from '../../../service/offer.service';
import { RouterLink } from '@angular/router';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Category } from '../../../model/category';
import { map, Observable, startWith } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GraphqlService } from '../../../service/graphql.service';
import { MatFormField } from '@angular/material/form-field';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-add-offers',
  templateUrl: './add-offers.component.html',
  imports: [
    RouterLink,
    MatFormField,
    MatAutocomplete,
    MatOption,
    ReactiveFormsModule,
    MatAutocompleteTrigger,
    AsyncPipe,
    MatInput,
  ],
  styleUrls: ['./add-offers.component.scss'],
  standalone: true,
})
export class AddOffersComponent implements OnInit {
  selectedFile: File | null = null;
  searchControl = new FormControl(); // Control for category search input
  categories: Category[] = []; // All categories
  selectedCategories: Category[] = []; // Categories selected by the user
  filteredCategories!: Observable<Category[]>; // Observable for filtered categories

  constructor(
    private offerService: OfferService,
    private snackBar: MatSnackBar,
    private graphqlService: GraphqlService,
  ) {}

  ngOnInit() {
    this.loadCategories();

    this.filteredCategories = this.searchControl.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value || '')),
    );
  }

  loadCategories() {
    this.graphqlService.allCategories().subscribe((categories: Category[]) => {
      console.log(categories);
      this.categories = categories;
    });
  }

  // Filter categories based on search input
  private _filter(value: string): Category[] {
    const filterValue = value.toLowerCase();
    return this.categories.filter((category) =>
      category.name.toLowerCase().includes(filterValue),
    );
  }

  // Handle file selection
  onFileChange(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.selectedFile = file;
      console.log('Datei ausgewählt:', this.selectedFile);
    }
  }

  // Add selected category if not already added
  addCategory(selectedCategory: Category) {
    if (
      !this.selectedCategories.find(
        (category) => category.id === selectedCategory.id,
      )
    ) {
      this.selectedCategories.push(selectedCategory);
    }
    this.searchControl.setValue(''); // Reset search control
  }

  // Remove category from selected categories
  removeCategory(category: Category) {
    this.selectedCategories = this.selectedCategories.filter(
      (cat) => cat.id !== category.id,
    );
  }

  // Submit file and selected categories to the backend
  uploadFile() {
    if (!this.selectedFile || this.selectedCategories.length === 0) {
      this.snackBar.open(
        'Bitte Datei und mindestens eine Kategorie auswählen.',
        'Schließen',
        {
          duration: 3000,
        },
      );
      return;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);

    // Send both file and category IDs as arguments
    const categoryIds = this.selectedCategories.map((cat) => cat.id);
    this.offerService.uploadOffersFile(formData, categoryIds).subscribe({
      next: (response) => {
        console.log('Angebote erfolgreich hochgeladen', response);
        this.snackBar.open('Angebote erfolgreich eingereicht!', 'Schließen', {
          duration: 3000,
        });
        this.resetForm();
      },
      error: (error) => {
        console.error('Fehler beim Hochladen der Angebote', error);
        this.snackBar.open('Fehler beim Hochladen der Angebote.', 'Schließen', {
          duration: 3000,
        });
      },
    });
  }

  // Reset form after successful submission
  resetForm() {
    this.selectedFile = null;
    this.selectedCategories = [];
    this.searchControl.setValue('');
  }

  downloadTemplate() {
    const templateUrl = '/assets/offers-template/AddOffers.xlsx';
    const link = document.createElement('a');
    link.href = templateUrl;
    link.download = 'AddOffers.xlsx';
    link.click();
  }
}
